import { DefaultVoyageType } from '@hooks/LaunchDarkly/LaunchDarkly.types';

interface DeparturePortOptions {
	code: string;
	label: string;
}
interface DeparturePortGroup {
	code: string;
	label: string;
	options: DeparturePortOptions[];
}

export const getRiverDeparturePorts = (departurePortsApplied: string[] | undefined, departurePortsGroups: DeparturePortGroup[]): string[] => {
	if (!departurePortsApplied || departurePortsApplied.length === 0) return [];
	const riverDeparturePorts: string[] = [];

	const riverDepartureGroups = departurePortsGroups.filter((group) => group.code.toUpperCase().includes(DefaultVoyageType.RIVER));
	riverDepartureGroups.forEach((group) => {
		group.options.forEach((option) => {
			if (departurePortsApplied.includes(option.code)) {
				riverDeparturePorts.push(option.code);
			}
		});
	});

	return riverDeparturePorts;
};
